import React, { useState } from "react";
import genRequest from "includes/request";
import { usePopper } from "react-popper";
import { useQuery, useQueryClient } from "react-query";
import { ReactionButton } from "Pages/Reactions/AdminReactionsPage";
import "./ReactionsPopper.css";
import useAccount from "classes/Accounts/hooks/useAccount";

export default function PostReactionsPopper({ postId, postTypeId, close, referenceElement }) {
	// const [popperElement, setPopperElement] = useState(null);
	const { account } = useAccount();
	// const { styles, attributes } = usePopper(referenceElement, popperElement, {
	// 	placement: "top"
	// });

	const { isLoading, data } = useQuery(
		["Lt_PostAvailableReaction", "PostId", postId],
		() => genRequest(`LT_DefaultReactionOfPostForCompany/ofPostTypeIdAndCompanyId/${postTypeId}/${account.CompanyId}`),
	);

	if (isLoading || !data?.length)
		return (false);

	return (
		<div
			className="ReactionsPopper"
			// ref={setPopperElement}
			onMouseLeave={close}
		// style={styles.popper}
		// {...attributes.popper}
		>
			<ReactionsList item={data[0]} postId={postId} />
		</div>
	);
}

export function PostReactions({ postId, onClick, title, titleClassName }) {
	const { isLoading, data } = useQuery(
		["Lt_PostAvailableReaction", "PostId", postId],
		() => genRequest("Lt_PostAvailableReaction/PostId/" + postId)
	);

	if (isLoading || !data?.length)
		return (false);

	if (title)
		return (
			<div>
				<div className={"mb-1" + (titleClassName ? " " + titleClassName : "")}>{title}</div>
				<PostReactions postId={postId} onClick={false} />
			</div>
		);
	return (
		<ReactionsList
			item={data[0]}
			postId={postId}
			onClick={onClick}
		/>
	);
}

export function ReactionsList(props) {
	const { account } = useAccount();
	const QCL = useQueryClient();
	const { item, postId, onClick } = props;

	// La route DELETE matche son DERNIER segment comme un ReactionId (malgré son nom
	// "...ReactionTypeId" côté API). Lui envoyer le ReactionTypeId ne matche aucune ligne
	// → 404 → la réaction précédente n'est jamais supprimée → doublons + 409 au re-clic.
	// On lit donc d'abord les réactions actuelles de l'utilisateur via l'endpoint PAR
	// EMPLOYÉ (qui n'est PAS filtré par site → fonctionne même sur un post d'un autre
	// site, contrairement aux routes par post) puis on supprime chacune par son
	// ReactionId. Ça retire l'ancienne réaction avant d'en poser une nouvelle et nettoie
	// au passage d'éventuels doublons hérités.
	const removeMyReactions = () => genRequest(
		"LT_Employe_Reaction_Post/EmployeIdAndPostId/" + account.EmployesId + "/" + postId
	).then(
		(mine) => Promise.all((Array.isArray(mine) ? mine : []).map((r) => genRequest(
			"LT_Employe_Reaction_Post/EmployeIdAndPostIdAndReactionTypeId/" + account.EmployesId + "/" + postId + "/" + r.ReactionId,
			null,
			"delete"
		).catch(() => null))),
		() => null
	);

	const sendReact = (reaction) => genRequest(
		"Lt_Employe_Reaction_Post",
		{
			ReactionId: reaction.ReactionId,
			EmployesId: account.EmployesId,
			PostId: postId
		},
		"post"
	);

	const countKey = (reactionId) => ["LT_Employe_Reaction_Post", "PostIdAndReactionId", postId, reactionId];

	// L'utilisateur n'a qu'UNE réaction par type : on le retire de la liste puis on
	// le rajoute sur l'émoji cliqué (total inchangé s'il changeait juste d'émoji,
	// +1 si c'est sa 1re réaction). Le compteur global (LikePostBtn) somme ces mêmes
	// clés par émoji, donc il suit ces updates automatiquement.
	const bumpUser = (old, reactionId) => {
		const arr = Array.isArray(old) ? old.filter((r) => r.EmployesId !== account.EmployesId) : [];
		if (reactionId)
			arr.push({ EmployesId: account.EmployesId, PostId: postId, ReactionId: reactionId });
		return arr;
	};

	const handleClick = (reac) => {
		if (onClick === false)
			return (false);
		if (onClick)
			return (onClick(reac));

		// Mise à jour optimiste des compteurs par émoji : ils bougent immédiatement au
		// clic, sans dépendre du GET rejoué juste après le POST (celui-ci peut renvoyer
		// une valeur en retard le temps que l'écriture se propage côté API).
		const emojis = data || [];
		const snapshots = emojis.map((e) => [e.ReactionId, QCL.getQueryData(countKey(e.ReactionId))]);

		emojis.forEach((e) => {
			QCL.setQueryData(countKey(e.ReactionId), (old) => bumpUser(old, e.ReactionId === reac.ReactionId ? reac.ReactionId : null));
		});

		// removeMyReactions() retire d'abord la/les réaction(s) existante(s) de
		// l'utilisateur (par ReactionId) ; à la 1re réaction la liste est vide et rien
		// n'est supprimé. Puis on poste la nouvelle réaction.
		let req = removeMyReactions()
			.then(() => sendReact(reac))
			.then(() => {
				// Réconcilie avec la vérité serveur (compteurs par émoji).
				QCL.invalidateQueries(["LT_Employe_Reaction_Post", "PostIdAndReactionId", postId]);
			})
			.catch((e) => {
				// Échec du POST : on restaure les compteurs d'avant le clic.
				snapshots.forEach(([reactionId, val]) => QCL.setQueryData(countKey(reactionId), val));
				console.error("ReactionsPopper: réaction échouée", e);
			});
		return (req);
	};

	const { data, isLoading } = useQuery(
		["Reactions", "Typed", item.ReactionTypeId],
		() => genRequest("Reactions/Typed/" + item.ReactionTypeId)
	);

	if (isLoading || !data?.length)
		return (false);

	return (
		<div
			className={"ReactionListCell d-flex w-100 justify-content-around align-items-center px-2" + (onClick === false ? " pe-none" : "")}>
			{
				data.map((a) => {
					return (
						<ReactionButton
							key={a.ReactionId}
							{...a}
							onClick={() => handleClick(a)}
							countQueryKey={["LT_Employe_Reaction_Post", "PostIdAndReactionId", postId, a.ReactionId]}
							countQueryFn={() => genRequest("LT_Employe_Reaction_Post/PostIdAndReactionId/" + postId + "/" + a.ReactionId)}
						/>
					);
				})
			}
		</div>
	);
}

